// FBN Chapters extracted from member data
export const FBN_CHAPTERS = [
  "Asia",
  "Belgium",
  "Brazil",
  "Bulgaria",
  "Canada",
  "Chile",
  "Colombia",
  "Czechia",
  "Denmark",
  "Ecuador",
  "Finland",
  "France",
  "Germany",
  "Gulf",
  "Hungary",
  "India",
  "Italy",
  "Japan",
  "Levant",
  "Luxembourg",
  "Morocco",
  "Netherlands",
  "USA",
  "Norway",
  "Panama",
  "Poland",
  "Slovakia",
  "Slovenia",
  "Spain",
  "Sweden",
  "Switzerland",
  "Türkiye",
  "Ukraine",
  "World",
] as const;

// Segment/Role options - keep order aligned with SegmentBadge color palette
export const SEGMENT_OPTIONS = [
  "Entrepreneur",
  "Intrapreneur",
  "Expander",
  "Investor",
  "Aspiring Entrepreneur",
  "Aspiring Intrapreneur",
  "Aspiring Investor",
  "Aspiring Expander",
] as const;

export const SEGMENT_DESCRIPTIONS: Record<(typeof SEGMENT_OPTIONS)[number], string> = {
  Entrepreneur: "Building a new venture outside the family business.",
  Intrapreneur: "Driving innovation inside the family business.",
  Expander: "Growing the family business into new markets, products, or territories.",
  Investor: "Backing entrepreneurs and ventures with capital, expertise, or networks.",
  "Aspiring Entrepreneur": "Exploring a new venture outside the family business.",
  "Aspiring Intrapreneur": "Learning how to drive innovation from within.",
  "Aspiring Investor": "Learning the craft of backing other entrepreneurs.",
  "Aspiring Expander": "Learning how to grow a family business into new markets, products, or territories.",
};

// Industry interest options
export const INDUSTRY_OPTIONS = [
  "Enterprise Software",
  "Public Sector",
  "AgriTech",
  "FinTech",
  "HealthTech",
  "EdTech",
  "CleanTech",
  "Real Estate",
  "Consumer Goods",
  "Food & Beverage",
  "Manufacturing",
  "Logistics",
  "Media & Entertainment",
  "Retail",
  "Energy",
] as const;

// Project type options
export const PROJECT_TYPE_OPTIONS = [
  "Business/Startup",
  "New Product/Service Line",
  "Philanthropic",
  "Investment",
  "Research/Writing",
  "Other",
] as const;

// SDG Goals with full names
export const SDG_GOALS = [
  { value: "#1 - No poverty", label: "No Poverty", number: 1 },
  { value: "#2 - Zero hunger", label: "Zero Hunger", number: 2 },
  { value: "#3 - Good health and well-being", label: "Good Health", number: 3 },
  { value: "#4 - Quality Education", label: "Quality Education", number: 4 },
  { value: "#5 - Gender equality", label: "Gender Equality", number: 5 },
  { value: "#6 - Clean water and sanitation", label: "Clean Water", number: 6 },
  { value: "#7 - Affordable and clean energy", label: "Clean Energy", number: 7 },
  { value: "#8 - Decent work and economic growth", label: "Economic Growth", number: 8 },
  { value: "#9 - Industry, Innovation and infrastructure", label: "Innovation", number: 9 },
  { value: "#10 - Reduced inequalities", label: "Reduced Inequalities", number: 10 },
  { value: "#11- Sustainable cities and communities", label: "Sustainable Cities", number: 11 },
  { value: "#12- Responsible consumption and production", label: "Responsible Consumption", number: 12 },
  { value: "#13 - Climate action", label: "Climate Action", number: 13 },
  { value: "#14 - Life below water", label: "Life Below Water", number: 14 },
  { value: "#15 - Life on land", label: "Life on Land", number: 15 },
  { value: "#16 - Peace, justice and strong institutions", label: "Peace & Justice", number: 16 },
  { value: "#17 - Partnerships for the goal", label: "Partnerships", number: 17 },
] as const;
